<template>
  <div class="ChongzhiRecordPage-wrapper">
    <van-empty v-if="this.list.length == 0" description="暂无记录" />
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="this.list.length != 0 ? '没有更多了' : ''"
      @load="onLoad"
    >
      <van-cell class="item-wrapper" v-for="(item, index) in list" :key="index">
        <div class="up-wrapper">
          <span class="lf-title">{{item.title}}</span>
          <span class="buy-time">{{createTime(item.createTime)}}</span>
        </div>
        <p>购买成功</p>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
  import { groupBuyOrderpaid} from "@/api/user";
  import Vue from "vue";
  import {dateFormat} from "@/lib/util";

  export default {
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        page: 0,
      }
    },

    created() {

    },

    activated() {

    },

    methods: {
      createTime(time) {
        return dateFormat(time, 'YYYY-MM-DD hh:mm')
      },

      onLoad() {
        //加载列表数据
        setTimeout(() => {
          this.requset_groupBuyOrderpaid()
        }, 500)
      },

      //加载订单数据
      requset_groupBuyOrderpaid() {
        let _THAT = this;
        let params = {pageIndex: _THAT.page, pageSize: 30};
        groupBuyOrderpaid(params).then(res => {
            _THAT.loading = false;
            if (res.code === 0) {
              if (_THAT.page == 1){
                _THAT.list = [];
              }

              if (res.data.records && res.data.records.length > 0) {
                _THAT.list.push(...res.data.records)
              }
              if ((res.data.records && res.data.records.length < 30) || (!res.data.records)) {
                _THAT.finished = true;
              }
              _THAT.page++;
            } else {
              _THAT.finished = true;
            }
          }
        ).catch((err) => {
          this.$toast(JSON.stringify(err))
          _THAT.loading = false;
          _THAT.finished = true;
        })
      },

      //================================================
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .ChongzhiRecordPage-wrapper {
    box-sizing: border-box;
    min-height: 100vh;
    padding: 8px 20px;
    background-color: #F3F5F9;
    font-size: 14PX;
    color: #333;
    overflow: hidden;
  }

  .item-wrapper {
    background-color: #fff;
    margin-top: 8px;
    border-radius: 6px;
    padding: 10px 10px;
    font-size: 14PX;
    color: #999;

    .up-wrapper {
      display: flex;
      justify-content: space-between;
      padding: 2px 0;

      .lf-title{
        color: #5597EC;
        font-weight: bold;
        font-size: 16PX;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// app/pages/tabs/Mine/BuyRecord.vue